import Alpine from 'alpinejs';

import './modules/splide'

import '../../views/atoms/custom-select/custom-select';
import '../../views/atoms/call-back/call-back';

import '../../views/components/stage/stage';
import '../../views/components/large-teaser/large-teaser';
import '../../views/components/header/header';
import '../../views/components/hero/hero';
import '../../views/components/job-teaser/job-teaser';
import '../../views/components/accordion/accordion';
import '../../views/components/fast-track-application/fast-track-application';
import '../../views/components/personal-request-application/personal-request-application';
import '../../views/components/footer/footer';
import '../../views/components/large-text-teaser/large-text-teaser';
import '../../views/components/job-search/job-search';
import '../../views/components/job-search/job-search-details/job-search-details';
import '../../views/components/job-search/job-search-filter/job-search-filter';
import '../../views/components/job-search/job-search-form/job-search-form';
import '../../views/components/job-search/job-search-preview/job-search-preview';
import '../../views/components/job-search/job-search-results/job-search-results';
import '../../views/components/magazin-teaser/magazin-teaser';
import '../../views/components/branches/branches';
import '../../views/components/cookie-banner/cookie-banner-generated';


window.addEventListener('load', Alpine.start);
